import { Helmet } from 'react-helmet';
import MobifoneDanhSachDonDetail
  from 'src/components/MobifoneDanhSachDon-detail/MobifoneDanhSachDonDetail';

import {
  Box,
  Container,
} from '@material-ui/core';

//import MobifoneDanhSachDonToolbar from '../components/MobifoneDanhSachDon-detail/MobifoneDanhSachDonToolbar';

const MobifoneDanhSachDon = () => (
  <>
    <Helmet>
      <title>Bắn tiền - Danh sách đơn</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container style={{maxWidth: "100%"}}>
        {/* <MobifoneDanhSachDonToolbar /> */}
        <Box sx={{ pt: 3 }}>
          <MobifoneDanhSachDonDetail />
        </Box>
      </Container>
    </Box>
  </>
);

export default MobifoneDanhSachDon;
